module.exports = {"id":"dp2_1l1q6","text":"Interacting Through Digital Technologies","instructions":"Which statement best describes a robot?","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_1l1q6-a1","text":"A non-human system performing tasks","score":1.8},{"id":"dp2_1l1q6-a2","text":"A human using digital tools","score":0},{"id":"dp2_1l1q6-a3","text":"A virtual meeting participant","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.1"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.1/l1q6.json
// module id = 991
// module chunks = 41